// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2ETyh","footer":"ModalUpdate_footer__2OVj-"};